import { render, staticRenderFns } from "./OtherTexts.vue?vue&type=template&id=436e0632&scoped=true&"
import script from "./OtherTexts.vue?vue&type=script&lang=js&"
export * from "./OtherTexts.vue?vue&type=script&lang=js&"
import style0 from "./OtherTexts.vue?vue&type=style&index=0&id=436e0632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e0632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
